import { render, staticRenderFns } from "./attenSetting.vue?vue&type=template&id=3d8ef858"
import script from "./attenSetting.vue?vue&type=script&lang=js"
export * from "./attenSetting.vue?vue&type=script&lang=js"
import style0 from "./attenSetting.vue?vue&type=style&index=0&id=3d8ef858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports